import axios from "axios";
import axiosInstance from "./axiosInstance";

class LotacaoServidorApi {
  cancelTokens = {
    getLotacaoServidor: null,
    getLotacaosServidor: null,
    setLotacaoServidor: null,
    destroyLotacaoServidor: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getLotacaoServidor(lotacaoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getLotacaoServidor = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/lotacoes_servidor/getLotacaoServidor/${lotacaoId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getLotacaoServidor = null;

    return data;
  }

  async getLotacaosServidor(servidorId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getLotacaosServidor = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}/lotacoes_servidor`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getLotacaosServidor = null;

    return data;
  }

  async setLotacaoServidor(lotacaoServidor) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setLotacaoServidor = source;

    const postData = { lotacoes_servidor: lotacaoServidor };

    if (lotacaoServidor.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/lotacoes_servidor/${lotacaoServidor.id}`,
        postData,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setLotacaoServidor = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/lotacoes_servidor`,
        postData,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setLotacaoServidor = null;

      return data;
    }
  }

  async destroyLotacaoServidor(lotacaoServidorId) {
    await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/lotacoes_servidor/${lotacaoServidorId}`,
    );
  }
}

export default LotacaoServidorApi;
